export const AI_CREDENTIALS_SECTION_ID = 'ai-credentials'

export const AI_CREDENTIALS_COPY = {
  title: 'AI 供應商',
  loading: '載入 AI 供應商設定…',
  intro: 'AI 分類、建議草稿和知識庫都用你公司自己的帳戶，費用直接由所選供應商向你收取。知識庫向量固定用 Vertex AI。',
  unavailable: '尚未設定 Vertex AI，AI 功能已暫停。新訊息仍會進來，但不會自動分類或草擬建議。',
  vertexTitle: 'Vertex AI（必填）',
  vertexHint: '用於知識庫向量；選為 AI provider 時也用於分類和建議草稿。',
  typesafeTitle: 'TypeSafe（可選）',
  typesafeHint: '設定後用 TypeSafe 判斷分類；未設定時改用主要 AI provider 分類。',
  typesafeMissing: '尚未設定 TypeSafe，分類會改用主要 AI provider。',
  anthropicTitle: 'Claude（可選）',
  anthropicHint: '可以在上面的「主要／備援 AI provider」選 anthropic_claude 做分類和建議草稿。知識庫向量仍然用 Vertex AI。',
  anthropicMissing: '尚未設定 Claude。填入你公司自己的 Anthropic API 金鑰後，才可以把 anthropic_claude 選為 AI provider。',
  anthropicUnusable: '這組 Claude 設定目前無法使用（金鑰讀不到或模型已停用），請更改設定並重新輸入金鑰，或移除。',
  pasteJson: '貼上服務帳戶 JSON 金鑰',
  pasteJsonHint: '在 Google Cloud 控制台「IAM 與管理 → 服務帳戶 → 金鑰」下載的 JSON 檔，打開後全選貼到這裡，會自動填入下面的欄位。內容只在這部裝置讀取，不會原封不動送出。',
  pasteJsonFilled: '已從 JSON 填入專案 ID、服務帳戶電郵和私鑰。',
  pasteJsonInvalid: '讀不到這份 JSON，請貼上完整的服務帳戶金鑰檔內容。',
  projectId: '專案 ID',
  location: '區域',
  locationHint: '一般用 us-central1，除非你的專案只開放其他區域。',
  clientEmail: '服務帳戶電郵',
  privateKey: '私鑰',
  privateKeyNew: '由 -----BEGIN PRIVATE KEY----- 開始。儲存後不會再顯示。',
  privateKeyKept: (date: string) => `已儲存（${date} 更新）。留空即沿用現有私鑰。`,
  chatModel: '對話模型',
  embeddingModel: '向量模型',
  anthropicModel: 'Claude 模型',
  apiKey: 'API 金鑰',
  apiKeyNew: '儲存後不會再顯示。',
  apiKeyKept: (date: string) => `已儲存（${date} 更新）。留空即沿用現有金鑰。`,
  model: '模型',
  secretStored: '已儲存',
  secretUpdatedAt: '金鑰更新',
  verifiedAt: '最後驗證',
  save: '驗證並儲存',
  saving: '驗證中…',
  saved: '已驗證並儲存',
  edit: '更改設定',
  cancel: '取消',
  remove: '移除',
  removing: '移除中…',
  removeVertexTitle: '移除 Vertex AI 金鑰',
  removeVertexBody: '移除後 AI 會即時暫停：新訊息仍會進來和通知你，但不會自動分類、草擬建議或更新知識庫，直到重新填入金鑰。',
  removeTypeSafeTitle: '移除 TypeSafe 金鑰',
  removeTypeSafeBody: '移除後分類會改用主要 AI provider。',
  removeAnthropicTitle: '移除 Claude 金鑰',
  removeAnthropicBody: '移除前請先把主要和備援 AI provider 改選其他供應商；仍在使用時系統會拒絕移除。',
  confirmRemove: '確認移除',
  invalid: {
    projectId: '專案 ID 格式不正確：6 至 30 個小寫英文字母、數字或連字號，並以字母開頭。',
    location: '區域格式不正確，例如 us-central1。',
    clientEmail: '服務帳戶電郵要以 .iam.gserviceaccount.com 結尾。',
    privateKey: '私鑰格式不正確，要由 -----BEGIN PRIVATE KEY----- 開始、-----END PRIVATE KEY----- 結束。',
    privateKeyRequired: '請貼上私鑰。',
    apiKeyRequired: '請輸入 API 金鑰。',
    apiKeyFormat: 'API 金鑰格式不正確，不可以有空格或全形字元。',
    model: '請輸入模型名稱。',
  },
} as const
